export interface RuntimeEnvConfig {
  displayWarningBanner: boolean;
}
